<template>
    <div>
        <Modal size="sm" @close="$emit('close')">
            <template #header>
                <div class="text-custom-red-600">
                    {{ $t("vue.remove_team_member") }}
                </div>
            </template>

            <template #body>
                <div class="p-6 text-sm leading-normal text-gray-500">
                    {{ $t("vue.you_are_about_to_remove") }}
                    <span class="font-medium text-gray-800">{{
                        member?.name
                    }}</span>
                    ({{ member?.email }}) {{ $t("vue.from_team") }}
                    <span class="font-medium text-gray-800">{{
                        team.name
                    }}</span
                    >.
                </div>
            </template>

            <template #footer>
                <div class="flex justify-between border-t border-gray-200 p-6">
                    <AtomicButton
                        color="white"
                        size="md"
                        @click="$emit('close')"
                    >
                        {{ $t("vue.cancel") }}
                    </AtomicButton>
                    <AtomicButton
                        color="red"
                        size="md"
                        @click="$emit('remove')"
                    >
                        {{ $t("vue.remove_team_member_button") }}
                    </AtomicButton>
                </div>
            </template>
        </Modal>
    </div>
</template>

<script lang="ts" setup>
import type IUser from "@/types/Members/IUser";
import type ICurrentTeam from "@/types/Members/ICurrentTeam";

defineProps<{
    member?: IUser;
    team: ICurrentTeam;
}>();

defineEmits(["close", "remove"]);
</script>

<style></style>
